/**
 * Unified member portal context for /club-academy/:orgSlug/* routes.
 */

import { create } from 'zustand';
import type { Academy } from '@court-sync/shared';
import type { PublicOrganizationProfile } from '@/services/publicOrg';

interface OrgMemberState {
  orgSlug: string | null;
  orgProfile: PublicOrganizationProfile | null;
  academy: Academy | null;
  clubSlug: string | null;
  setOrgContext: (
    slug: string,
    profile: PublicOrganizationProfile,
    academy: Academy | null,
    clubSlug: string | null
  ) => void;
  clearOrgContext: () => void;
}

export const useOrgMemberStore = create<OrgMemberState>((set) => ({
  orgSlug: null,
  orgProfile: null,
  academy: null,
  clubSlug: null,
  setOrgContext: (slug, profile, academy, clubSlug) =>
    set({ orgSlug: slug, orgProfile: profile, academy, clubSlug }),
  clearOrgContext: () =>
    set({ orgSlug: null, orgProfile: null, academy: null, clubSlug: null }),
}));
